/**
 * Sold-out restock countdown. Ticks only when a real stock window exists.
 * Cirro "expected October" counts down to 2026-10-01 (window start, not delivery).
 * Never invents a clock for unknown allocation.
 */
(function () {
  var CIRRO = {
    "meaco-cirro-12000": "2026-10-01T00:00:00+01:00",
    "meaco-cirro-14000-heat": "2026-10-01T00:00:00+01:00",
  };
  var MONTHS = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11,
  };

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function parseIso(raw) {
    if (!raw || typeof raw !== "string") return null;
    var s = raw.trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += "T00:00:00+01:00";
    var t = Date.parse(s);
    return Number.isFinite(t) ? t : null;
  }

  function parseExpectedWindow(label) {
    if (!label) return null;
    var iso = label.match(/expected[^\d]{0,24}(\d{4}-\d{2}-\d{2})/i);
    if (iso) return parseIso(iso[1]);
    var month = label.match(
      /expected\s+(january|february|march|april|may|june|july|august|september|october|november|december)(?:\s+(\d{4}))?/i
    );
    if (!month) return null;
    var year = month[2] ? parseInt(month[2], 10) : 2026;
    var m = MONTHS[month[1].toLowerCase()];
    if (m == null || !Number.isFinite(year)) return null;
    var offset = m >= 2 && m <= 9 ? "+01:00" : "+00:00";
    return parseIso(year + "-" + pad(m + 1) + "-01T00:00:00" + offset);
  }

  function resolveTarget(root) {
    var fromAttr = parseIso(root.getAttribute("data-window-start") || "");
    if (fromAttr != null) return fromAttr;
    var handle = root.getAttribute("data-handle") || "";
    if (CIRRO[handle]) return parseIso(CIRRO[handle]);
    return parseExpectedWindow(root.getAttribute("data-eta-label") || "");
  }

  function formatRemain(ms) {
    if (ms <= 0) return null;
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var mins = Math.floor((total % 3600) / 60);
    var secs = total % 60;
    if (days > 0) return days + "d " + pad(hours) + "h " + pad(mins) + "m";
    if (hours > 0) return hours + "h " + pad(mins) + "m " + pad(secs) + "s";
    return mins + "m " + pad(secs) + "s";
  }

  function ensureClockUi(root) {
    var countEl = root.querySelector("[data-restock-count]");
    if (countEl) return countEl;
    var eyebrow = root.querySelector(".pdp__restock__eyebrow");
    if (eyebrow) eyebrow.textContent = "Predicted inventory back";
    var label = document.createElement("p");
    label.className = "pdp__restock__label";
    label.textContent = "Expected stock window";
    countEl = document.createElement("p");
    countEl.className = "pdp__restock__count";
    countEl.setAttribute("data-restock-count", "");
    var note = root.querySelector(".pdp__restock__note");
    var insertBefore = note || null;
    if (insertBefore) {
      root.insertBefore(label, insertBefore);
      root.insertBefore(countEl, insertBefore);
      note.textContent = "Window start, not a delivery day.";
    } else {
      root.appendChild(label);
      root.appendChild(countEl);
    }
    return countEl;
  }

  function bind(root) {
    if (!root || root.getAttribute("data-restock-bound") === "1") return;
    var target = resolveTarget(root);
    if (target == null) return;
    var countEl = ensureClockUi(root);
    root.setAttribute("data-restock-bound", "1");
    root.setAttribute("data-restock-mode", "window");
    root.classList.add("pdp__restock--window");
    root.classList.remove("pdp__restock--month", "pdp__restock--confirm");

    function tick() {
      var remain = formatRemain(target - Date.now());
      if (!remain) {
        countEl.hidden = true;
        var noteEl = root.querySelector(".pdp__restock__note");
        if (noteEl) {
          noteEl.textContent = "Stock window is open. We'll confirm when this model is booked.";
        }
        return;
      }
      countEl.hidden = false;
      countEl.textContent = remain;
      window.setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    document.querySelectorAll("[data-restock-bubble]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
